export enum CART_SOURCE {
  DEFAULT_PAGE,
  PDP_PAGE,
  CART_PAGE,
  ODP_PAGE,
}

export enum CartClientId {
  PDP = 1,
  ITEM_CARD,
  BUNDLE_DEAL_LANDING_PAGE,
  ADD_ON_DEAL_LANDING_PAGE,
  VOUCHER_LANDING_PAGE,
  CHOICE_FLOATING_COUNTER,
  LATAM_FLOATING_COUNTER,
  FLOATING_CART,
  MINI_CART,
  GIFT_WITH_PURCHASE_LANDING_PAGE,
  MAIN_CART,
  MINI_FEED,
}

export const ATC_ERROR_CODE = Object.freeze({
  CART_BFF_PARTIAL_FULFILMENT_ERROR: 15020008,
  CART_BFF_ADD_ON_DEAL_SUB_ITEM_INVALID: 15020009,
  CART_BFF_ADD_ON_DEAL_MAIN_ITEM_INVALID: 15020010,
  CART_BFF_ADD_ON_DEAL_EXPIRED: 15020011,
  CART_BFF_TOTAL_QUANTITY_EXCEEDED: 15020018,
  CART_BFF_USER_NOT_FULFILL_KYC: 15020022,
  CART_BFF_USER_PLATFORM_NOT_UPDATED: 15020023,
  NEW_CART_BFF_USER_NOT_FULFILL_KYC: 209020022,
  NEW_CART_BFF_USER_PLATFORM_NOT_UPDATED: 209020023,
});
